import { Banco } from '@app/models/banco.model';
import { Unidade } from '@app/models/unidade.model';

export class Conta {
  public Id: number;
  public Descricao: string;
  public Numero: string;
  public Banco: Banco;
  public BancoId: number;
  public Agencia: string;
  public Saldo: number;
  public Limite: number;
  public Compensado: number;
  public Ativo: boolean;
  public Convenio: string;
  public OutroDado1: string;
  public OutroDado2: string;
  public NossoNumero: number;
  public Instrucao1: string;
  public Instrucao2: string;
  public Carteira: string;
  public RemessaNumero: number;
  public LayoutRemessa: string;
  public LayoutRetorno: string;
  public NomeTitular: string;
  public BancoNome: string;
  public Unidade: Unidade;
  public UnidadeId: number;

  constructor() {
    this.Id = 0;
    this.Limite = 0;
    this.Saldo = 0;
    this.Compensado = 0;
    this.BancoId = 0;
    this.Ativo = true;
  }
}
